export default "__VITE_ASSET__D6gR93G9__"